import owd from 'owd/owd';

export default class Accordion extends owd.Component {
	init() {
        this.expadable = this.$element.find('[data-accordion-expandable]').first();
        this.trigger = this.$element.find('[data-accordion-trigger]').first();
        
        this.initAttribiutes();
		this.bind();
	}
    
    initAttribiutes() {
        const timestamp = Date.now();
        
        let id = `accordion-${timestamp}`;
        
        if($(`#${id}`).length) {
            id = `accordion-${timestamp + 1}`;
        } 
        
        this.expadable.attr({
            id,
            'aria-hidden': true
        });
        
        this.trigger.attr({
            'aria-controls': id,
            'aria-expanded': false
        });
    }

	bind() {
        this.on('click', this.trigger, (e) => {
            e.preventDefault();
            
            this.$element.toggleClass('is-expanded');
            
            const isExpanded = this.$element.hasClass('is-expanded');
            
            this.expadable.slideToggle('fast').attr('aria-hidden', !isExpanded);
            
            this.trigger.attr('aria-expanded', isExpanded);
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('accordion', {
	component: Accordion
});
